import { useQuery } from '@tanstack/react-query'
import { Table, Input, Select } from 'antd'
import { Search } from 'lucide-react'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import ExcelButton from '@components/ExcelButton'
import Header from '@components/header'
import Layout from '@components/Layout'
import OrderPaymentModal from '@components/Modal/orderPaymentModal'
import ViewSalesModal from '@components/Modal/ViewSalesWithDocEntryModal'
import { http } from '@services/http'
import { columnDebtors } from '@utils/columns'
import { debouncedSet } from '@utils/debounce'
import { downloadExcel } from '@utils/downloadPdf'
import {
	fetchDebtors,
	fetchOneSeeSales,
	fetchSalesPerson,
} from '@utils/fetchData'
import { numberWithSpacesIntl } from '@utils/numberWithSpaces'

const Debtors = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const { getMe, roleNames } = useSelector((state) => state.main)

	const [currentPage, setCurrentPage] = useState(0)
	const [cardName, setCardName] = useState('')
	const [docNum, setDocNum] = useState('')
	const [isModalVisible, setIsModalVisible] = useState(false)
	const [isPaymentModalVisible, setIsPaymentModalVisible] = useState(false)
	const [selectedRowData, setSelectedRowData] = useState(null)
	const [slpAdmin, setSlpAdmin] = useState('')
	const [pageSize] = useState(1000)
	const [loadingExcel, setLoadingExcel] = useState(false)

	const isAdminOrCashier =
		roleNames.includes('admin') || roleNames.includes('Cashier')

	const { data = [], isLoading } = useQuery({
		queryKey: [
			'debtors',
			currentPage,
			cardName,
			docNum,
			isAdminOrCashier ? slpAdmin : getMe?.salesPersonCode,
			pageSize,
		],
		queryFn: fetchDebtors,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const { data: slpData = [], isLoading: slpLoading } = useQuery({
		queryKey: ['salesPerson'],
		queryFn: fetchSalesPerson,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const {
		data: oneSeeSalesData = [],
		isLoading: oneSeeSalesLoading,
		refetch: oneSeeSalesRefetch,
	} = useQuery({
		queryKey: ['seeSales', data[0]?.cardCode, docNum, data.length === 1],
		queryFn: fetchOneSeeSales,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	useEffect(() => {
		if (data.length === 1 && oneSeeSalesData) {
			// setIsPaymentModalVisible(true) // opens the document when search is done
			fetchOneSale(oneSeeSalesData[0]?.docEntry)
			// setSelectedRowData(oneSeeSalesData[0])
		}
	}, [oneSeeSalesData, data])

	const handleNextPage = () => {
		if (data.length === 10) {
			setCurrentPage((prevPage) => prevPage + 1)
		}
	}

	const handlePreviousPage = () => {
		if (currentPage > 0) {
			setCurrentPage((prevPage) => prevPage - 1)
		}
	}

	const handleCardNameChange = (val) => {
		debouncedSet(val, setCardName)
	}

	const handleDocNumChange = (val) => {
		debouncedSet(val, setDocNum)
	}

	const handleSeeBtnClick = (cardCode) => {
		navigate(
			`/see-sales-customers?cardCode=${encodeURIComponent(cardCode)}`,
		)
	}

	const fetchOneSale = async (docEntry) => {
		if (!docEntry) return
		try {
			const url = `api/sales/sotuv-buyurtmasi?docEntry=${docEntry}`
			const { data } = await http.get(url)
			setSelectedRowData(data.data[0])
		} catch (error) {
			console.log(error)
		}
	}

	const handlePayBtnClick = () => {
		setIsPaymentModalVisible(true)
		fetchOneSale(oneSeeSalesData[0].docEntry)
	}
	const handleViewSalesClick = () => {
		setIsModalVisible(true)
		setSelectedRowData(oneSeeSalesData[0])
	}

	const showPayBtn = data.length === 1 && oneSeeSalesData
	const showViewSales = data.length === 1 && oneSeeSalesData

	const columns = columnDebtors(
		t,
		handleCardNameChange,
		handleSeeBtnClick,
		showPayBtn,
		handlePayBtnClick,
		showViewSales,
		handleViewSalesClick,
	)

	const handleDownloadExcel = () => {
		downloadExcel({
			url: 'api/excelgenerators/export-debitors',
			params: {
				cardName,
				docNum,
				slpCode: isAdminOrCashier ? slpAdmin : getMe?.salesPersonCode,
				pageToken: 0,
				pageSize: 1000,
			},
			fileName: 'Qarzdorlar',
			onLoadingChange: setLoadingExcel,
		})
	}

	return (
		<Layout>
			<div className="m-5 border-[2px] border-gray-200">
				<div className="flex w-fullitems-center justify-between   ml-4 mr-4 mt-10 sm:ml-10 sm:mr-10 sm:mt-14 ">
					<h1 className="font-poppins text-xl font-bold text-black  sm:text-xl">
						{t('Accounts receivable')}
					</h1>
					<ExcelButton
						handleDownloadExcel={handleDownloadExcel}
						loadingExcel={loadingExcel}
					/>
				</div>

				<div className="mt-8 w-full border-[1px] border-[#E8E8E8] sm:mt-8"></div>

				<div className="mt-6 sm:ml-10 sm:mt-10">
					<div className="mb-4 flex flex-col justify-end items-end sm:flex-row">
						{/* <div className="flex items-end ">
							<div className=" flex sm:mr-10">
								<div className="flex flex-col gap-3">
									<p>{t('docNum')}</p>
									<Input.Search
										// value={docNum}
										onChange={(e) =>
											handleDocNumChange(e.target.value)
										}
										className="w-[250px] h-8"
										placeholder={t('docNum')}
									/>
								</div>
							</div>
							{isAdminOrCashier && (
								<div className="flex flex-col gap-3">
									<p>{t('salesManager')}</p>
									<Select
										value={slpAdmin}
										onChange={setSlpAdmin}
										className="w-[150px] h-8"
										options={[
											{
												value: '',
												label: t('all'),
											},
											...slpData.map((item) => ({
												value: item.slpCode,
												label: item.slpName,
											})),
										]}
									/>
								</div>
							)}
						</div> */}
						<div className=" flex sm:mr-10">
							<span className="font-bold">
								{t('totalDebt')} :{' '}
								{numberWithSpacesIntl(
									data?.reduce(
										(acc, cur) => acc + cur.balance,
										0,
									),
								)}
							</span>
						</div>

						{/* <div className="mt-2 flex sm:mr-10">
							<button
								onClick={handlePreviousPage}
								disabled={currentPage === 0}
								className="h-[30px] w-[110px] bg-[#0A4D68] text-white disabled:bg-gray-200 disabled:text-gray-400 "
							>
								{t('previous')}
							</button>
							<div className="bg-[#099204]  w-[20px] h-[30px] flex items-center  justify-center">
								<span className="text-center text-white">
									{currentPage + 1}
								</span>
							</div>
							<button
								onClick={handleNextPage}
								disabled={!data.length === 10}
								className="h-[30px] w-[110px] bg-[#0A4D68] text-white disabled:bg-gray-200 disabled:text-gray-400 "
							>
								{t('next')}
							</button>
						</div> */}
					</div>

					<div className="mr-10 mt-10 mb-10">
						<Table
							columns={columns}
							dataSource={data}
							pagination={false}
							bordered
							className="w-full"
							rowKey="docEntry"
							loading={isLoading}
						/>
					</div>
				</div>
			</div>
			<ViewSalesModal
				visible={isModalVisible}
				data={selectedRowData}
				onClose={() => setIsModalVisible(false)}
				ship={false}
				incoming={false}
			/>
			<OrderPaymentModal
				visible={isPaymentModalVisible}
				data={selectedRowData}
				onClose={() => setIsPaymentModalVisible(false)}
			/>
		</Layout>
	)
}

export default Debtors
